<form
  class="form-container"
  novalidate
>
  <mat-form-field>
    <mat-label>Connection</mat-label>
    <input
      type="text"
      matInput
      [formField]="rootForm.connection"
    />
    <mat-hint>The name of the thread connection</mat-hint>
    @if (rootForm.connection().touched() && rootForm.connection().invalid()) {
      @for (error of rootForm.connection().errors(); track error.kind) {
        <mat-error>{{ error.message }}</mat-error>
      }
    }
  </mat-form-field>

  @if (isCheckingSimilarConnections()) {
    <p class="similar-connections-hint">
      <mat-icon>hourglass_empty</mat-icon>
      Checking for similar connection names&hellip;
    </p>
  } @else if (similarConnectionNames().length) {
    <p class="similar-connections-warning">
      <mat-icon>warning</mat-icon>
      Similar connection{{ similarConnectionNames().length > 1 ? "s" : "" }} already exist:
      {{ similarConnectionNames().join(", ") }}
    </p>
  }

  <mat-form-field>
    <mat-label>Revision</mat-label>
    <input
      type="text"
      matInput
      [formField]="rootForm.revision"
    />
    <mat-hint>The revision for this connection</mat-hint>
    @if (rootForm.revision().touched() && rootForm.revision().invalid()) {
      @for (error of rootForm.revision().errors(); track error.kind) {
        <mat-error>{{ error.message }}</mat-error>
      }
    }
  </mat-form-field>

  <div class="end-field">
    <span id="add-connection-end-label">End</span>
    <mat-radio-group
      aria-labelledby="add-connection-end-label"
      [formField]="rootForm.end"
    >
      <mat-radio-button value="PIN">Pin</mat-radio-button>
      <mat-radio-button value="BOX">Box</mat-radio-button>
    </mat-radio-group>
    @if (rootForm.end().touched() && rootForm.end().invalid()) {
      <mat-error role="alert">Choose pin or box</mat-error>
    }
  </div>
</form>
